import axios from 'axios';
interface SignedMavenUserData {
  family_name: string;
  given_name: string;
  id: string;
  jwt: string;
  primary_email: string;
  primary_phone_number: string | null;
}

export async function getMavenUserData() {
  const res = await axios.get<SignedMavenUserData>('/maven/user');
  return res.data;
}
